import { FC } from 'react'

export const AvatarGroup: FC = ({ children }) => {
  return (
    <div className="relative w-full h-12 flex mb-5 -space-x-7">{children}</div>
  )
}
